
module.exports = function(bootstrap) {
    bootstrap.directive('draggable', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {

                element[0].addEventListener('dragstart', scope.dragAndDrop.dragStart, false);
                element[0].addEventListener('dragend', scope.dragAndDrop.dragEnd, false);

            }
        }
    })
};